var map = {
	"./coop_cubes.png": 326,
	"./flappy_bird.png": 994,
	"./golf_3d.png": 502,
	"./hotline_miami.png": 935,
	"./pong.png": 772,
	"./rush_battle.jpg": 223,
	"./rush_boss.jpg": 514,
	"./rush_boss_explosion.jpg": 498,
	"./rush_hover.jpg": 155,
	"./rush_ice_spell.jpg": 35,
	"./rush_ui.jpg": 315,
	"./rush_weapon.jpg": 249,
	"./sonic.png": 175,
	"./splinter_begin_demo.png": 801,
	"./splinter_demo.png": 607,
	"./splinter_hint.png": 217,
	"./tank_shoot.png": 770,
	"./tower_defense.png": 134
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 556;